import React from 'react';

export interface IMenuCategoryModuleProps {
    code: string;
}

export const MenuCategoryModule = (props: IMenuCategoryModuleProps) => {
    return <div>{props.code}</div>;
}